import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { LocaleProvider } from 'antd';
import { Provider as ReduxProvider } from 'react-redux';
import { createStore, applyMiddleware, combineReducers } from "redux";
import thunk from 'redux-thunk';
import lodash from 'lodash';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import Loading from 'components/RouteLoading';
import renderRoutes from 'libs/routes';
import createContext from 'libs/context';
import http from 'libs/http';
import Login from '../pages/login'
import './index.less';
import '../mock';

import editAtlas from '../pages/content/photos/edit/reducer';

moment.locale('zh-cn');

const { Provider } = createContext('authority', {});
const store = createStore(combineReducers({
  fetchState: (state = {}, action) => {
    if (action.type === 'REQUESTING') {
      return {
        ...state,
        loading: true,
        tip: action.payload.tip,
      }
    } else if (action.type === 'REQUEST_DONE') {
      return {
        ...state,
        loading: false,
        tip: '',
      }
    }
    return state
  },
  ...editAtlas,
}), applyMiddleware(thunk))

class Root extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      initData: {
        authority: {},
        menuList: [],
        siteList: [],
        userName: '',
        siteName: '',
        siteId: ''
      }
    };
  }

  componentDidMount() {
    this.initData();
  }
  
  //数据初始化
  initData = () => {
    let promistList = [];
    if (window.location.href.includes('/chosite')) {
      promistList = [
        http.json('/sys/index/choiceInit'),
        '',
        ''
      ]
    } else {
      promistList = [
        http.json('/sys/index/choiceInit'),
        http.get('/sys/menu/init'),
        http.json('/sys/menu/top'),
        http.get('/sys/notice/top')
      ];
    }
    Promise.all(promistList).then(res => {
      const authority = {};
      const siteList = lodash.get(res, '[0].siteList', []);
      const menuList = lodash.get(res, '[1].menuList', []);
      const functionList = lodash.get(res, '[1].functionList', []);
      const userName = lodash.get(res, '[2].userName', '');
      const siteName = lodash.get(res, '[2].siteName', '');
      const notice = lodash.get(res, '[3].notice', '');
      let siteId = '';
      functionList.forEach(item => authority[item] = true);
      siteList.forEach(item => {
        if (item.name === siteName) {
          siteId = item.id;
        }
      });
      this.setState({
        loading: false,
        initData: { authority, menuList, siteList, userName, siteName, siteId, notice }
      });
    }).catch((res) => {
      if (res.code === 1 || res.code === 99) {
        this.setState({ visible: true })
      }
      this.setState({ loading: false })
    });
  }

  render() {
    const { loading, initData, visible  } = this.state;
    if (loading) return <Loading />;
    return (
      <LocaleProvider locale={zhCN}>
        <ReduxProvider store={store}>
          <div id='login-dom'>
            <Login  visible={true}></Login>
          </div>
          <Router>
            <Provider value={{ ...initData }}>
              {renderRoutes('/', initData.authority)}
            </Provider>
          </Router>
        </ReduxProvider>
      </LocaleProvider>
    );
  }
}

export default Root;
